import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { GetData, DeleteData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router";

function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const navigate = useNavigate();
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);
  const Handler = (pageNumber = 1, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, index).then((result) => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = (data) => {
    setstate({ ...state, loading: true });
    DeleteData(data);
    GetData().then((result) => {
      Handler();
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست محتوا</title>
      </Helmet>
      <DataTable
        heads={[
          {
            title: "دسته بندی",
            keyName: "name",
            key: "category",
          },
          {
            title: "نام شهر",
            keyName: "name",
            key: "city",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        loading={state.loading}
        textEmpty="محتوای  ثبت نشده"
        list={state.data.data}
        data={state.data}
        function={Handler}
        currentPage={state.data && state.data.current_page}
        header=" لیست محتوا"
        textbtn="ایجاد محتوا"
        linkbtn="/Admin/ContentBox/Create"
        links={[
          {
            function: (selected) => {
              HandlerDelete({ content_id: selected[0] });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: (selected) => {
              let id = state.data.data.filter(
                content => content.id === selected[0]
              )[0].id;
              navigate({
                pathname: `/Admin/ContentBox/edit/${id}`,
              });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
        ]}
      />
    </Fragment>
  );
}

export default List;
